/**
 * Runtime configuration — read from Vite env vars at build time.
 *
 * Values come from:
 *   - .env (committed defaults, if any)
 *   - .env.local (git-ignored, local dev)
 *   - .env.production (committed, used by vite build for prod)
 *
 * At deploy time, the production env vars come from the CloudFormation stack outputs
 * (see `docs/RUNBOOK-admin-platform-deployment.md` Stage 2.2).
 */

function must(name: string): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Missing required env var ${name}. See .env.example.`);
  }
  return value;
}

export const config = {
  cognito: {
    userPoolId: must('VITE_ADMIN_USER_POOL_ID'),
    clientId: must('VITE_ADMIN_USER_POOL_CLIENT_ID'),
    region: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
  },
  api: {
    baseUrl: must('VITE_ADMIN_API_BASE_URL'),
  },
  env: import.meta.env.MODE as 'development' | 'production',
} as const;
